<mat-card>
  <h2 translate>prescriberContactData.title</h2>
  <p translate>prescriberContactData.subtitle</p>
  <form [formGroup]="prescriberDataForm">
    <div fxFlex fxLayout="row wrap" class="form-wrapper">
      <div fxFlex="40" fxFlex.gt-sm="30">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>prescriberContactData.phone</mat-label>
          <input
            #prescriberPhone
            id="prescriberPhone"
            formControlName="prescriberPhone"
            matInput
            type="text"
            maxlength="9"
            required
            (keypress)="alphanumericHyphenBackslash($event, prescriberPhone)"
            (blur)="onMobilePhoneBlur($event, prescriberPhone)"
          />

          <mat-hint translate>prescriberContactData.allRequired</mat-hint>
          <mat-error
            *ngIf="
              prescriberDataForm.controls.prescriberPhone.hasError('required') &&
              isAutos &&
              prescriberDataForm.controls['prescriberName'].value !== ''
            "
            translate
          >
            prescriberContactData.allRequired
          </mat-error>
          <mat-error *ngIf="prescriberDataForm.controls.prescriberPhone.hasError('required') && !isAutos" translate>
            prescriberContactData.atLEastOneRequired
          </mat-error>
          <mat-error *ngIf="prescriberDataForm.controls.prescriberPhone.hasError('telephoneInvalid')" translate>
            field.error.telefono
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="60" fxFlex.gt-sm="30">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>prescriberContactData.mail</mat-label>
          <input
            id="prescriberMail"
            formControlName="prescriberMail"
            matInput
            type="text"
            maxlength="60"
            (blur)="showPopUpEmail()"
            required
          />
          <mat-hint translate>prescriberContactData.allRequired</mat-hint>
          <mat-error *ngIf="prescriberDataForm.controls.prescriberMail.hasError('emailInvalid')" translate>
            field.error.email
          </mat-error>
          <mat-error
            *ngIf="
              prescriberDataForm.controls.prescriberMail.hasError('required') &&
              isAutos &&
              prescriberDataForm.controls['prescriberName'].value !== ''
            "
            translate
          >
            prescriberContactData.allRequired
          </mat-error>
          <mat-error *ngIf="prescriberDataForm.controls.prescriberMail.hasError('required') && !isAutos" translate>
            prescriberContactData.atLEastOneRequired
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-card>
